<template>
  <div>
    <v-app-bar absolute id="app-bar" color="#81C0E2" style="height: 64px" elevate-on-scroll scroll-target="#scrolling-techniques-7">
      <div class="d-inline-block" style="width:160px">
        <v-img :src="images.new_logo" width=280 alt="中華企業資源規劃學會LOGO"></v-img>
      </div>
    </v-app-bar>
    <v-row style="height:64px; width:100%">
    </v-row>
    <v-row class="ma-5">
      <v-btn class="ma-0 pa-0" outlined style="width:130px; height:40px; background:#FFF; border-radius:8px; border: 1px solid #969698" @click="redirectPath('/login')">
        <v-icon style="color:#969698">mdi-arrow-left-bold-circle-outline</v-icon>
        <span class="px-1" style="font-size:13pt; color:#969698">回登入頁</span>
      </v-btn>
    </v-row>

    <v-card class="my-3 py-3" color="#FFF" style="box-shadow:none; overflow-x:hidden; overflow-y:scroll" align="center" :style="viewStyle">
      <div id="box2" class="pa-5 py-10 col-10 col-sm-10 col-md-8 col-lg-6">
        <v-row style="margin-top:3%; margin-left:3%">
          <div class="mx-5 firstBar"></div>
          <h4 class="pr-8" style="font-size:26px">忘記密碼</h4>
        </v-row>
        <v-row class="mt-2" justify="center">
          <v-col class="py-0 col-11 col-sm-10 col-md-9 col-lg-8">
            <div class="text-left pt-2 pt14">帳號(身分證字號)</div>
              <v-text-field class="mt-2 border pt14" dense background-color="white" outlined placeholder="請輸入身分證字號" v-model="memberIdCard"
              @keyup="memberIdCard = memberIdCard.replace(/[\u4e00-\u9fa5]/ig,'') && memberIdCard.toUpperCase(), memberIdCard = $Global.toCDB(memberIdCard)"></v-text-field>
          </v-col>
        </v-row>
        <v-row class="pt-8 pb-2" justify="center">
          <v-img :src="images.forget" contain height="160" alt="忘記密碼搜尋圖示"></v-img>
        </v-row>
        <v-row class="mt-2" justify="center">
          <v-btn class="mb-5 mx-1 loginBack col-10 col-sm-5 col-lg-4" outlined style="height:40px" @click="redirectPath('/login')">
            <span style="color:#81c0e2">回登入畫面</span>
          </v-btn>
          <v-btn class="mb-5 mx-1 loginBtn col-10 col-sm-5 col-lg-4" outlined style="height:40px" @click="forgotPassword()">
            <span style="color:#FFFFFF">送出資料</span>
          </v-btn>
        </v-row>
      </div>
      <div class="mt-6 col-10">
        <h4 style="font-size:12px">中華企業資源規劃學會 版權所有，禁止未經授權轉貼節錄</h4>
        <h4 style="font-size:12px"> 2009 中華企業資源規劃學會．Chinese Enterprise Resource Planning Society.</h4>
        <h4 style="font-size:12px">校址：(32001)桃園市中壢區中大路300號 管理學院二館6F Tel：(03)426-4248 Fax：(03)426-0076</h4>
      </div>
    </v-card>
    <ReceiveMail ref="ReceiveMail" :onSave="onSave"/>
    <ShowMsg ref="ShowMsg" />
  </div>
</template>

<script>

import ReceiveMail from '@/dialogs/ReceiveMail'
import CryptoJS from "crypto-js"
import ShowMsg from '@/dialogs/ShowMsg'

export default {
  name: 'ForgetPassword',
  components: {ReceiveMail,ShowMsg},
  data:()=>({
    viewStyle:{},
    images:{
      new_logo: require('@/assets/image/erp_logo.png'),
      forget: require('@/assets/image/forget.png')
    },
    memberIdCard:'',
    idCardInfo: {},
    msg:'',
  }),
  watch:{
    "memberIdCard":function(){
      if(this.memberIdCard.length > 5){
        this.idCardInfo = {}
        this.$Global.getIdCardInfo(this.memberIdCard).then(res=>{ this.idCardInfo = res })
      }
    },
  },
  mounted(){
    this.calculateWindows()
    this.$root.$on('windowInnerHeight',()=>{
      this.calculateWindows()
    })
  },
  methods:{
    calculateWindows(){
      this.viewStyle = {height: window.innerHeight-144+ 'px'}
    },
    redirectPath(path){
      this.$router.push(path)
    },
    forgotPassword(){
      if(this.idCardInfo.erpTeacher && this.idCardInfo.erpMember){
        this.$refs.ShowMsg.open(0,'請確認身分證','請確認是否輸入正確身分證，若無法變更密碼，請撥打電話 03-4264248 聯繫管理人員。')
        return
      }
      if(this.idCardInfo.erpTeacher == this.idCardInfo.erpMember){
        this.$refs.ShowMsg.open(0,'請確認身分證','請確認是否輸入正確身分證，若無法變更密碼，請撥打電話 03-4264248 聯繫管理人員。')
        return
      }
      var self = this
      var request = {
        method: 'POST',
        url: '/common/forgotPassword',
        data: this.Qs.stringify({
          idCard: this.memberIdCard,
        }),
      }
      this.$http(request).then(function(response) {
        self.msg = response.data.msg
      }).catch(()=>{
        self.$refs.ShowMsg.open(0,'系統錯誤','請聯繫系統管理人員，編號為Fgp-7956')
      }).finally(()=>{
        if(self.msg == '成功!'){
          self.$refs.ReceiveMail.open()
        }
      })
    },
    onSave(){
      this.redirectPath('/login')
    }
  }
}
</script>
